import { useAtom } from "jotai";
import { useEffect } from "react";
import { DateTime } from "luxon";
import dataService from "../../../helpers/dataService";
import tools from "../../../helpers/tools";
import useManagers from "../../../hooks/useManagers/useManagers";
import {
  isLoadingPjListAtom,
  isPjListInitAtom,
  pjListAtom,
  pjListFiltersAtom,
  PJ_SEARCH_TYPES,
} from "./atoms/pjRenewListAtoms";

const usePjRenewList = () => {
  const [pjList, setPjList] = useAtom(pjListAtom);
  const [isLoadingPjList, setIsLoadingPjList] = useAtom(isLoadingPjListAtom);
  const [pjListFilters, setPjListFilters] = useAtom(pjListFiltersAtom);
  const [isPjListInit, setIsPjListInit] = useAtom(isPjListInitAtom);
  const { managers } = useManagers();

  const getFormattedPjs = (apiPjs, applicableFilters) => {
    const newPjs = apiPjs.map((d) => {
      const beginDate = DateTime.now();
      const endDate = DateTime.fromISO(d.productData.endAt);
      const daysDifference = endDate.diff(beginDate, "days").days;
      return {
        ...d,
        comments: tools.populateNamesFromId(managers, d.comments),
        daysDifference,
        // l'API peut renvoyer terminationDate null (contrat sans statusAt) :
        // le mode de recherche fait foi pour l'affichage « résilié »
        isTerminatedSearch:
          applicableFilters.searchType == PJ_SEARCH_TYPES.RESILIES,
      };
    });

    return applicableFilters.searchType == PJ_SEARCH_TYPES.A_RENOUVELER &&
      applicableFilters.filters.renewableInNbDays
      ? newPjs.sort((a, b) => a.daysDifference - b.daysDifference)
      : newPjs;
  };

  const getPjList = (overrideFilters = null) => {
    setIsLoadingPjList(true);
    if (overrideFilters) {
      setPjListFilters(overrideFilters);
    }
    const applicableFilters = overrideFilters || pjListFilters;
    dataService.post(
      `policies/renewals/search`,
      applicableFilters,
      (datas) => {
        setPjList({
          ...datas,
          data: getFormattedPjs(datas.data, applicableFilters),
        });
        setIsPjListInit(true);
      },
      (err) => {},
      () => setIsLoadingPjList(false)
    );
  };

  const changeSearch = ({ searchType, filters }) => {
    getPjList({ searchType, page: 1, filters });
  };

  const updatePage = (page) => {
    const newFilters = {
      ...pjListFilters,
      page,
    };
    getPjList(newFilters);
    setPjListFilters(newFilters);
  };

  return {
    pjList,
    isLoadingPjList,
    pjListFilters,
    actions: {
      getPjList,
      changeSearch,
      updatePage,
    },
  };
};

export default usePjRenewList;
